import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import it from './locales/it.json';
import fr from './locales/fr.json';
import ja from './locales/ja.json';
import zh from './locales/zh.json';
import ru from './locales/ru.json';

const STORAGE_KEY = 'timestampgit-language';
const supportedLanguages = ['en', 'de', 'es', 'pt', 'it', 'fr', 'ja', 'zh', 'ru'];

function getInitialLanguage() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && supportedLanguages.includes(saved)) {
    return saved;
  }

  const browserLanguage = (navigator.language || 'en').slice(0, 2).toLowerCase();
  if (supportedLanguages.includes(browserLanguage)) {
    return browserLanguage;
  }

  return 'en';
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    es: { translation: es },
    pt: { translation: pt },
    it: { translation: it },
    fr: { translation: fr },
    ja: { translation: ja },
    zh: { translation: zh },
    ru: { translation: ru },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export { STORAGE_KEY, supportedLanguages };
export default i18n;
